import React, { useEffect, useState } from "react";
import MainLayout from "../layouts/MainLayout";
import { InputField, SelectField } from "../components/FormItems/FormItems";
import FormLayout from "../layouts/FormLayout";
import { Button } from "../components/Button/Button";

import { fetchPageData } from "../endpoint/pageApi";

const ContactForm = ({ data }) => {
  return (
    <>
      <FormLayout data={data?.landing_page}>
        {data?.landing_page?.form?.fields?.map((fieldData, idx) => (
          <React.Fragment key={idx}>
            {fieldData?.type !== "select" ? (
              <InputField
                className={`col-${fieldData?.column}`}
                label={fieldData?.label}
                extraContent={
                  fieldData?.muted_text && (
                    <span className="fs-6 " style={{ color: "#90A3BE" }}>
                      {fieldData?.muted_text}
                    </span>
                  )
                }
                placeholder={fieldData?.placeholder}
              />
            ) : (
              <SelectField
                className={`col-${fieldData?.column}`}
                label={fieldData?.label}
                placeholder={
                  fieldData?.placeholder ? fieldData?.placeholder : "Select"
                }
              />
            )}
          </React.Fragment>
        ))}

        <div className="col-12">
          {data?.landing_page?.form?.CTAs?.map((buttonData, idx) => (
            <Button
              className={"px-5 py-1"}
              background={buttonData?.backgroundColor}
              textColor={buttonData?.textColor}
            >
              {buttonData?.text}
            </Button>
          ))}
        </div>

        <div className="col-12">
          <span className="fs-6 " style={{ color: "#90A3BE" }}>
            {data?.landing_page?.form?.desclaimer}
          </span>
        </div>
      </FormLayout>
    </>
  );
};

const ContactUs = () => {
  // const paragraphs = [
  //   {
  //     para: "Lorem ipsum dolor sit amet consectetur. Ullamcorper turpis in eros etiam. Quam tempus hac morbi ullamcorper venenatis ultrices facilisis. Blandit ut integer etiam egestas pellentesque lorem felis facilisis. Imperdiet pellentesque augue tincidunt feugiat facilisi feugiat accumsan netus quisque.",
  //   },
  //   {
  //     para: "Lorem ipsum dolor sit amet consectetur. Ullamcorper turpis in eros etiam. Quam tempus hac morbi ullamcorper venenatis ultrices facilisis. Blandit ut integer etiam egestas pellentesque lorem felis facilisis. Imperdiet pellentesque augue tincidunt feugiat facilisi feugiat accumsan netus quisque.",
  //   },
  // ];

  const [pageData, setPageData] = useState({});
  const [loader, setLoader] = useState(false);

  useEffect(() => {
    fetchPageData(
      "pages?filters[slug][$eq]=contact-us",
      setPageData,
      setLoader
    );
  }, []);

  return (
    <>
      <MainLayout loader={loader}>
        <ContactForm data={pageData} />
        {/* Thank You Page On Form Submission */}
        {/* <ThankyouPage
          msg="Our team will get back to you"
          appreciationHeading="Thank you!"
          paragraphs={paragraphs}
          buttonName="Back to Home"
        /> */}
      </MainLayout>
    </>
  );
};

export default ContactUs;
